import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    noDataContainer: {
      padding: 30,
      color: colors.secondaryGray,
      backgroundColor: colors.lighterSmoke
    },
    triggerButton: {
      cursor: 'pointer',
      color: colors.primary
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: colors.approxBlack,
      background: colors.white,
      borderColor: colors.pixelWhite,
      fontFamily: FONT_FAMILY
    },
    modal: {
      height: '93%',
      overflowY: 'auto',
      background: colors.historyObservationBackground
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: colors.historyObservationBackground
    },
    container: {
      flex: 1,
      minHeight: 300,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: colors.historyObservationBackground
    },
    closeIcon: {
      cursor: 'pointer'
    },
    cursorDefault: {
      cursor: 'default'
    },
    tableContainer: needShowTrendLine => {
      return {
        marginTop: needShowTrendLine ? 50 : 0,
        border: colors.approxBlack
      }
    },
    tableHeader: {
      color: colors.approxBlack,
      fontWeight: 'bold',
      backgroundColor: colors.cerebralGrey,
      textAlign: 'center',
      padding: 20
    },
    table: {
      backgroundColor: colors.lighterSmoke
    },
    tableCell: {
      color: colors.approxBlack,
      backgroundColor: colors.lighterSmoke,
      padding: 20,
      textAlign: 'center'
    },
    result: isInRange => {
      return {
        fontWeight: 'bold',
        color: isInRange ? colors.approxBlack : '#111111',
        backgroundColor: isInRange ? colors.lighterSmoke : colors.outRangeYellow
      }
    },
    errorContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '18.4px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.approxBlack,
      backgroundColor: colors.white
    },
    errorText: {
      margin: '0 10px',
      textAlign: 'center'
    }
  }
  return styles
}

export default themeStyles
